'use client';

import React from 'react';
import { cn } from '../../../utils/cn/cn';

/**
 * The dialog footer container
 * */
const DialogFooter = ({ children, className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cn('bg-color-background-base mt-auto p-2 shadow', className)} {...props}>
    <div className="xs:flex-col xs:items-stretch flex gap-1 md:flex-row-reverse md:items-center">
      {children}
    </div>
  </div>
);

DialogFooter.displayName = 'DialogFooter';

export { DialogFooter };
